module.exports = __webpack_public_path__ + "img/1970East-002_WEB-min.e292133f.jpg";